import { render, staticRenderFns } from "./GeoBody.vue?vue&type=template&id=3558a694&"
import script from "./GeoBody.vue?vue&type=script&lang=js&"
export * from "./GeoBody.vue?vue&type=script&lang=js&"
import style0 from "./GeoBody.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports